module.exports = __webpack_public_path__ + "static/img/4.61b6f14.png";


//////////////////
// WEBPACK FOOTER
// ./src/district/assets/image/home/4.png
// module id = 4XuX
// module chunks = 3